import type { SVGProps } from 'react';
const SvgSuccess = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <g clipPath="url(#Success_svg__a)">
      <path
        d="m5 9.093 1.225 1.682a.52.52 0 0 0 .42.225.54.54 0 0 0 .434-.2L11 6m-3 9A7 7 0 1 0 8 1a7 7 0 0 0 0 14"
        strokeLinejoin="round"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth={1.5}
      />
    </g>
    <defs>
      <clipPath id="Success_svg__a">
        <path d="M0 0h16v16H0z" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSuccess;
